import { z } from "zod"
import { CustomerImportTargetEnum, ImportStatusEnum } from "./commonTypes"

export const ImporterData = z.object({
  key: z.string(),
  title: z.string(),
  error: z.any(),
  data: z.any(),
  align: z.enum(["left", "right"]),
  kind: z.enum(["string", "number", "date", "select", "boolean", "json"]),
})

export const ImportCustomersResponseData = z.union([
  z.object({
    success: z.boolean(),
    totalCount: z.number(),
    errorsCount: z.number(),
    invalidRowsCount: z.number(),
    previewCount: z.number(),
    columns: z.array(z.object({ title: z.string(), target: CustomerImportTargetEnum })),
    defaultCountry: z.string().nullable(),
    data: z.array(z.array(ImporterData)),
  }),
  z.object({
    success: z.literal(true),
    importId: z.string().uuid(),
    status: ImportStatusEnum,
    totalRows: z.number(),
    isDuplicate: z.boolean(),
  }),
])

const ImportProgressBase = z.object({
  totalRows: z.number(),
  processedCount: z.number(),
  createdCount: z.number(),
  updatedCount: z.number(),
  failedCount: z.number(),
})

export const ImportStatusResponseDataSchema = z.discriminatedUnion("status", [
  ImportProgressBase.extend({ status: z.literal("QUEUED") }),
  ImportProgressBase.extend({ status: z.literal("PROCESSING") }),
  ImportProgressBase.extend({
    status: z.literal("FAILED"),
    errorMessage: z.string().nullable(),
  }),
  ImportProgressBase.extend({ status: z.literal("COMPLETED") }),
])

export const RunningImportsResponseDataSchema = z.array(z.object({ id: z.string().uuid() }))
